export default __webpack_public_path__ + "static/media/36I-102813_-16000_0.31aebaa9.jpg";